const ACTIONS = Object.freeze({
  find_my_fit: Object.freeze({ hash: '#velorten-find-my-fit', event: 'velorten:find-my-fit:open', element: 'velorten-find-my-fit' }),
  size_guide: Object.freeze({
    hash: '#velorten-size-guide',
    paths: Object.freeze(['/pages/size-guide']),
    event: 'velorten:size-guide:open',
    element: 'velorten-size-guide',
  }),
});

const normalizedPath = (pathname) => String(pathname || '').replace(/\/+$/, '') || '/';

const actionFromUrl = (url) => {
  const hashAction = actionFromHash(url.hash);
  if (hashAction) return hashAction;

  const pathname = normalizedPath(url.pathname);
  return Object.keys(ACTIONS).find((key) =>
    (ACTIONS[key].paths || []).some((path) => pathname.endsWith(path))
  ) || '';
};

const actionFromTrigger = (trigger) => {
  const configured = trigger?.dataset?.velortenModalAction;
  if (configured && ACTIONS[configured]) return configured;
  const href = trigger?.getAttribute?.('href')?.trim();
  if (!href) return '';

  try {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return '';
    return actionFromUrl(url);
  } catch {
    return actionFromHash(href);
  }
};

const actionFromHash = (hash) =>
  Object.keys(ACTIONS).find((key) => ACTIONS[key].hash === hash) || '';

const waitForDrawerClose = (trigger) => {
  const drawer = trigger?.closest?.('header-drawer');
  if (!drawer || typeof drawer.close !== 'function') {
    return Promise.resolve(trigger instanceof HTMLElement ? trigger : null);
  }

  const details = drawer.querySelector('details');
  const returnTrigger = details?.querySelector('summary') || trigger;
  drawer.close();
  if (!details?.hasAttribute('open')) return Promise.resolve(returnTrigger);

  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      observer.disconnect();
      clearTimeout(timer);
      resolve(returnTrigger);
    };
    const observer = new MutationObserver(() => {
      if (!details.hasAttribute('open')) finish();
    });
    const timer = setTimeout(finish, 600);
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });
  });
};

const openAction = async (action, trigger = null, source = 'global-trigger') => {
  const config = ACTIONS[action];
  if (!config) return;

  const returnTrigger = await waitForDrawerClose(trigger);
  await customElements.whenDefined(config.element);
  const modal = document.querySelector(config.element);
  if (!(modal instanceof HTMLElement)) return;

  document.dispatchEvent(new CustomEvent(config.event, {
    detail: {
      source,
      trigger: trigger instanceof HTMLElement ? trigger : null,
      returnTrigger: returnTrigger instanceof HTMLElement ? returnTrigger : null,
      sectionId: modal.dataset.sectionId || '',
      productId: modal.dataset.productId || '',
    },
  }));
};

if (document.documentElement.dataset.velortenModalActions !== 'true') {
  document.documentElement.dataset.velortenModalActions = 'true';

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-velorten-modal-action], a[href]')
      : null;
    if (!(trigger instanceof HTMLElement)) return;
    const action = actionFromTrigger(trigger);
    if (!action) return;
    event.preventDefault();
    openAction(action, trigger);
  }, { capture: true });

  window.addEventListener('hashchange', () => {
    const action = actionFromHash(window.location.hash);
    if (action) openAction(action, null, 'supported-hash');
  });

  const openInitialHash = () => {
    const action = actionFromUrl(new URL(window.location.href));
    if (action) openAction(action, null, 'initial-location');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openInitialHash, { once: true });
  } else {
    openInitialHash();
  }
}
